import { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { ALL_GROUPS } from "../global/variables/userGroups";

export default function useFetch(
  actionReducer,
  stateName = "",
  groups = ALL_GROUPS,
  timeout = 1000
) {
  const state = useSelector((state) => state);
  const dispatch = useDispatch();

  const groupIdentify = groups?.some((group) => state?.user?.data?.userGroup.includes(group));
  const token = state?.auth?.data?.token;

  useEffect(() => {
    setTimeout(() => {
      if (groupIdentify) return dispatch(actionReducer);
    }, timeout);
    // eslint-disable-next-line
  }, [dispatch, token]);

  return {
    data: stateName ? state[stateName].data : null,
  };
}
